import axios from "axios";
import { connection_platform } from "./configConnection";

const instance = axios.create({
  baseURL: connection_platform.urlCommunicatedDashboard
});

export default instance;
